import { atom } from 'jotai';

export const layoutViewAtom = atom<'grid' | 'list'>('list');
